import { render } from "./MailingBlockListEditor.vue?vue&type=template&id=6152622a"
import script from "./MailingBlockListEditor.vue?vue&type=script&lang=js"
export * from "./MailingBlockListEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__